import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class WhatsappVoiceCampaignService {

  constructor(private api: ApiService, private http: HttpClient) {}

  create(data: any): Observable<any> {
    return this.api.post(environment.createWhatsappVoiceCampaign, data);
  }

  update(data: any): Observable<any> {
    return this.api.post(environment.updateWhatsappVoiceCampaign, data);
  }

  list(data: any): Observable<any> {
    return this.api.post(environment.listWhatsappVoiceCampaigns, data);
  }

  getById(data: any): Observable<any> {
    return this.api.post(environment.getWhatsappVoiceCampaignById, data);
  }

  delete(data: any): Observable<any> {
    return this.api.post(environment.deleteWhatsappVoiceCampaign, data);
  }

  /** Execute a single batch — server handles per-call delays */
  executeBatch(data: { campaign_id: number; batch_index: number; contacts: any[] }): Observable<any> {
    return this.api.post(environment.executeWhatsappVoiceCampaignBatch, data);
  }

  /** Mark campaign as completed / failed */
  finish(data: { campaign_id: number; final_status: string }): Observable<any> {
    return this.api.post(environment.finishWhatsappVoiceCampaign, data);
  }

  /** Trigger campaign asynchronously on the backend (manual test route) */
  // manualTrigger(campaignId: number): Observable<any> {
  //   return this.api.post(environment.manualTriggerWhatsappVoiceCampaign, { campaign_id: campaignId });
  // }

  /** Trigger campaign asynchronously on the backend via SQS */
  runTelephonyCampaign(campaignId: number): Observable<any> {
    return this.api.post(environment.runTelephonyCampaign, { campaign_id: campaignId });
  }

  /** Fetch Call Campaign Analytics from external voice bot API */
  getCallAnalytics(clientId: any, campaignId: any, page: number = 1, limit: number = 20): Observable<any> {
    return this.http.get(`https://sdr-ai-voice-bot.gravitasai.in/call-analytics`, {
      params: {
        campaign_id: String(campaignId),
        client_id: String(clientId),
        page: String(page),
        limit: String(limit)
      }
    });
  }
}
